import PropTypes from 'prop-types';
import { Icon, Button } from '@evertrue/et-components';

/**
 * Wait step component for the cadence flow editor.
 * Display-only — editing happens in the side panel drawer.
 */
const WaitStep = ({ waitTime, onEdit, onDelete }) => {
  const duration = waitTime?.duration || 1;
  const unit = waitTime?.unit || 'days';

  return (
    <div className="wait-step">
      <div className="wait-step--connector">
        <div className="wait-step--line" />
        <div className="wait-step--content">
          <Icon icon="access-time" className="wait-step--icon" />
          <span className="wait-step--label">
            Wait {duration} {unit}
          </span>
          <div className="wait-step--actions" onClick={(e) => e.stopPropagation()}>
            <Button type="simple" onClick={onEdit} title="Edit wait time" className="wait-step--edit">
              <Icon icon="edit" />
            </Button>
            <Button type="simple" onClick={onDelete} title="Delete wait step" className="wait-step--delete">
              <Icon icon="close" />
            </Button>
          </div>
        </div>
        <div className="wait-step--line" />
      </div>
    </div>
  );
};

WaitStep.propTypes = {
  waitTime: PropTypes.shape({
    duration: PropTypes.number,
    unit: PropTypes.oneOf(['minutes', 'hours', 'days', 'weeks']),
  }),
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default WaitStep;
